export default {
  getDriedAbaloneSummaryItem: (state) => state.driedAbaloneSummaryItem,
};
